import React from "react";
import { Typography } from "@mui/material";
import "./AnatomyLabel.css";

export const AnatomyLabel = () => {
  return (
    <Typography
      sx={{
        fontSize: "1.2rem",
        // eslint-disable-next-line no-constant-condition
        fontWeight: false ? "bold" : null,
        // eslint-disable-next-line no-constant-condition
        color: false ? "secondary.main" : "primary.main",
      }}
    >
      <span className="non-selectable">Region & Allgemeinsymptome</span>
    </Typography>
  );
};
